import React, { useCallback, useContext, useEffect } from 'react';
import { Section, Alignment, Logo } from './styles';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

import { GoogleContext } from '../../hooks/useAuthGoogle';
import { GoogleContextType } from '../../@Types/index';

import logo from './img/AXS-logo.svg';

const TopBar: React.FC = () => {
    const { statusGoogle, saveStatusGoogle, saveUser } = useContext(GoogleContext) as GoogleContextType;

    const handleLogout = () => {
        saveStatusGoogle(false) 
        window.location.href = 'https://www.axsenergia.com.br/';
    }
  
    const checkGoogle = useCallback(() => {
        if(sessionStorage.getItem('googleUser')) {
           const google: string | any = sessionStorage.getItem('googleUser');
           const obj = JSON.parse(google) 
           if(obj){
            saveUser(obj.profileObj);
            saveStatusGoogle(true);
           }
        } 
    },[saveStatusGoogle, saveUser]);  
    
    useEffect(() => {
        if(!statusGoogle) checkGoogle();
    },[checkGoogle, statusGoogle])

    return (
    <Section>
        <Alignment>
            <Logo>
                <img src={logo} alt={"logo"} />
            </Logo>
            { (statusGoogle ) ? 
            <ExitToAppIcon fontSize='large' onClick={handleLogout} style={{ cursor: 'pointer' }} /> : ''
            }
        </Alignment> 
    </Section>
    )
  }

export default TopBar